/**
 * CF508 - Apple/macOS Dark Inspired Theme
 * Main JavaScript File
 */

// Wait for DOM to be loaded
document.addEventListener('DOMContentLoaded', function() {
  // Initialize components
  initMobileMenu();
  initAnimations();
  initProductGallery();
  initQuantitySelector();
  initStickyHeader();
  initMiniCart();
  initVariantSelector();
  initProductAddToCart();
  initAppleStyleScrolling();
  initPriceRangeFilter();
  initVideoTitle();
});

/**
 * Mobile Menu
 */
// Removing conflicting mobile menu code since we're using the implementation from mobile-menu-drawer.liquid

/**
 * Animations
 */
function initAnimations() {
  // Add animation classes to elements as they enter the viewport
  const animatedElements = document.querySelectorAll('.animate');
  
  if (!animatedElements.length) return;
  
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };
  
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animated');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  
  animatedElements.forEach(el => {
    observer.observe(el);
  });
}

/**
 * Product Gallery
 */
function initProductGallery() {
  const productMainImage = document.getElementById('ProductMainImage');
  const productThumbnails = document.querySelectorAll('.product-thumbnail');
  
  if (!productMainImage || !productThumbnails.length) return;
  
  productThumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function() {
      // Update active thumbnail
      productThumbnails.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      // Update main image
      const fullImage = this.querySelector('img').getAttribute('data-full-image');
      if (fullImage) {
        productMainImage.src = fullImage;
        
        // Fade animation
        productMainImage.style.opacity = '0';
        setTimeout(() => {
          productMainImage.style.opacity = '1';
        }, 50);
      }
    });
  });
  
  // Image zoom on hover (desktop only)
  if (window.innerWidth > 768) {
    const zoomContainer = document.querySelector('.product-main-image');
    
    if (zoomContainer) {
      zoomContainer.addEventListener('mousemove', function(e) {
        const zoomer = this;
        const offsetX = e.offsetX;
        const offsetY = e.offsetY;
        const x = offsetX / zoomer.offsetWidth * 100;
        const y = offsetY / zoomer.offsetHeight * 100;
        productMainImage.style.transformOrigin = `${x}% ${y}%`;
      });
      
      zoomContainer.addEventListener('mouseenter', function() {
        productMainImage.style.transform = 'scale(1.5)';
      });
      
      zoomContainer.addEventListener('mouseleave', function() {
        productMainImage.style.transform = 'scale(1)';
      });
    }
  }
}

/**
 * Quantity Selector
 */
function initQuantitySelector() {
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  
  if (!quantitySelectors.length) return;
  
  quantitySelectors.forEach(selector => {
    const input = selector.querySelector('input[type="number"]');
    const decreaseBtn = selector.querySelector('.quantity-decrease');
    const increaseBtn = selector.querySelector('.quantity-increase');
    
    if (input && decreaseBtn && increaseBtn) {
      decreaseBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value);
        if (currentValue > parseInt(input.min)) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      
      increaseBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value);
        if (currentValue < parseInt(input.max)) {
          input.value = currentValue + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}

/**
 * Sticky Header
 */
function initStickyHeader() {
  // Skip this function completely since we're handling the header in header.liquid
  // This prevents conflicting scroll handlers
  return;
  
  /*
  Original implementation commented out:
  const header = document.querySelector('header');
  const stickyEnabled = header && header.hasAttribute('data-sticky');
  
  if (!header || !stickyEnabled) return;
  
  let lastScrollTop = 0;
  const scrollThreshold = 50;
  
  window.addEventListener('scroll', function() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (currentScrollTop > scrollThreshold) {
      header.classList.add('sticky');
      
      // Hide/show header based on scroll direction
      if (currentScrollTop > lastScrollTop) {
        // Scrolling down
        header.classList.add('hide');
      } else {
        // Scrolling up
        header.classList.remove('hide');
      }
    } else {
      header.classList.remove('sticky');
      header.classList.remove('hide');
    }
    
    lastScrollTop = currentScrollTop;
  });
  */
}

/**
 * Mini Cart
 */
function initMiniCart() {
  const cartToggle = document.querySelector('.js-cart-toggle');
  const cartClose = document.querySelector('.js-cart-close');
  const cartDrawer = document.getElementById('cartDrawer');
  
  if (!cartToggle || !cartClose || !cartDrawer) return;
  
  cartToggle.addEventListener('click', function(e) {
    e.preventDefault();
    cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  
  cartClose.addEventListener('click', function() {
    cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  });
  
  // Close cart when clicking outside
  document.addEventListener('click', function(e) {
    if (cartDrawer.classList.contains('open') && 
        !cartDrawer.contains(e.target) && 
        !cartToggle.contains(e.target)) {
      cartDrawer.classList.remove('open');
      document.body.style.overflow = '';
    }
  });
  
  // Prevent clicks inside cart from closing it
  cartDrawer.addEventListener('click', function(e) {
    e.stopPropagation();
  });
  
  // Handle cart item quantity changes
  const quantityInputs = document.querySelectorAll('.cart-item-quantity input');
  
  if (quantityInputs.length) {
    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        const cartItemKey = this.getAttribute('data-item-key');
        const newQuantity = parseInt(this.value);
        
        if (cartItemKey && !isNaN(newQuantity)) {
          updateCartItemQuantity(cartItemKey, newQuantity);
        }
      });
    });
  }
}

/**
 * Update Cart Item Quantity
 * @param {string} itemKey - The cart item key
 * @param {number} quantity - The new quantity
 */
function updateCartItemQuantity(itemKey, quantity) {
  const data = {
    id: itemKey,
    quantity: quantity
  };
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(cart => {
    // Update cart count
    const cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      cartCount.textContent = cart.item_count;
    }
    
    // Update cart totals
    const cartTotalAmount = document.querySelector('.cart-total-amount');
    if (cartTotalAmount) {
      let formattedTotal = formatMoney(cart.total_price);
      cartTotalAmount.textContent = formattedTotal;
    }
    
    // If quantity is 0, remove the item from the DOM
    if (quantity === 0) {
      const cartItem = document.querySelector(`[data-item-key="${itemKey}"]`).closest('.cart-item');
      if (cartItem) {
        cartItem.style.opacity = '0';
        setTimeout(() => {
          cartItem.remove();
          
          // Show empty cart message if no items
          if (cart.item_count === 0) {
            const cartItems = document.querySelector('.cart-items');
            if (cartItems) {
              cartItems.innerHTML = '<p>Your cart is empty</p>';
            }
          }
        }, 300);
      }
    }
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

/**
 * Format money values according to theme settings
 * @param {number} cents - Value in cents
 * @return {string} Formatted money value
 */
function formatMoney(cents) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  const dollars = cents / 100;
  return '$' + dollars.toFixed(2);
}

/**
 * Variant Selector
 */
function initVariantSelector() {
  const variantOptions = document.querySelectorAll('.variant-option');
  
  if (!variantOptions.length) return;
  
  variantOptions.forEach(option => {
    option.addEventListener('click', function() {
      const variantGroup = this.closest('.variant-options');
      const optionIndex = variantGroup.getAttribute('data-option-index');
      const optionValue = this.getAttribute('data-value');
      
      // Update selected state
      const siblings = variantGroup.querySelectorAll('.variant-option');
      siblings.forEach(sib => sib.classList.remove('selected'));
      this.classList.add('selected');
      
      // Update the hidden select
      const selector = document.querySelector(`select[data-index="${optionIndex}"]`);
      if (selector) {
        selector.value = optionValue;
        selector.dispatchEvent(new Event('change'));
      }
      
      // Trigger variant change event
      document.dispatchEvent(new CustomEvent('variant:changed'));
    });
  });
}

/**
 * Product Add to Cart
 */
function initProductAddToCart() {
  const addToCartForm = document.querySelector('form[action="/cart/add"]');
  
  if (!addToCartForm) return;
  
  addToCartForm.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const submitButton = this.querySelector('button[type="submit"]');
    const originalButtonText = submitButton.innerHTML;
    
    // Show loading state
    submitButton.innerHTML = 'Adding...';
    submitButton.disabled = true;
    
    // Serialize form data
    const formData = new FormData(this);
    
    // Add to cart via Ajax
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(item => {
      // Success state
      submitButton.innerHTML = 'Added!';
      
      // Update cart count via Ajax
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(cart => {
      // Update cart count
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      }
      
      // Open cart drawer
      const cartDrawer = document.getElementById('cartDrawer');
      if (cartDrawer) {
        cartDrawer.classList.add('open');
        document.body.style.overflow = 'hidden';
      }
      
      // Reset button after a delay
      setTimeout(() => {
        submitButton.innerHTML = originalButtonText;
        submitButton.disabled = false;
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      
      // Error state
      submitButton.innerHTML = 'Error';
      
      // Reset button after a delay
      setTimeout(() => {
        submitButton.innerHTML = originalButtonText;
        submitButton.disabled = false;
      }, 2000);
    });
  });
}

/**
 * Apple-Style Smooth Scrolling
 */
function initAppleStyleScrolling() {
  // Add smooth scrolling to all links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      
      // Skip if href is just "#"
      if (href === '#') return;
      
      const target = document.querySelector(href);
      
      if (target) {
        e.preventDefault();
        
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
  
  // Add smooth scroll to top button
  const scrollTopButton = document.querySelector('.scroll-top');
  
  if (scrollTopButton) {
    // Show/hide button based on scroll position
    window.addEventListener('scroll', function() {
      if (window.pageYOffset > 500) {
        scrollTopButton.classList.add('visible');
      } else {
        scrollTopButton.classList.remove('visible');
      }
    });
    
    // Scroll to top when clicked
    scrollTopButton.addEventListener('click', function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
}

// Price Range Filter
class PriceRangeFilter {
  constructor() {
    this.slider = document.querySelector('.price-range-filter__slider');
    this.minThumb = document.querySelector('.price-range-filter__thumb--min');
    this.maxThumb = document.querySelector('.price-range-filter__thumb--max');
    this.track = document.querySelector('.price-range-filter__track');
    this.minValue = document.querySelector('.price-range-filter__min');
    this.maxValue = document.querySelector('.price-range-filter__max');
    this.histogram = document.querySelector('.price-range-filter__histogram');
    this.applyButton = document.querySelector('#applyPriceFilter');
    
    this.minPrice = 0;
    this.maxPrice = 0;
    this.currentMin = 0;
    this.currentMax = 0;
    this.priceData = [];
    
   
  }
  
  
  
  logDebug(message, type = 'info') {
    const color = type === 'error' ? 'red' : type === 'success' ? 'green' : 'white';
    const debugLine = document.createElement('div');
    debugLine.style.color = color;
    debugLine.textContent = `[${new Date().toLocaleTimeString()}] ${message}`;
    this.debugContainer.appendChild(debugLine);
    console.log(`[${type}] ${message}`);
  }
  
  renderHistogram() {
    if (!this.histogram) {
      this.logDebug('Histogram element not found', 'error');
      return;
    }
    
    // Clear existing bars
    this.histogram.innerHTML = '';
    
    if (!this.priceData.length) {
      this.logDebug('No price data available', 'error');
      return;
    }
    
    // Create price ranges
    const rangeSize = (this.maxPrice - this.minPrice) / 20; // 20 bars
    const ranges = [];
    
    for (let i = 0; i < 20; i++) {
      const start = this.minPrice + (i * rangeSize);
      const end = start + rangeSize;
      const count = this.priceData.filter(price => price >= start && price < end).length;
      ranges.push({ start, end, count });
    }
    
    // Find max count for scaling
    const maxCount = Math.max(...ranges.map(r => r.count));
    this.logDebug(`Histogram ranges: ${JSON.stringify(ranges)}`);
    
    // Create bars
    ranges.forEach((range, index) => {
      const bar = document.createElement('div');
      bar.className = 'price-range-filter__bar';
      const height = maxCount > 0 ? (range.count / maxCount) * 100 : 0;
      bar.style.height = `${height}%`;
      bar.setAttribute('data-count', range.count);
      bar.setAttribute('data-start', range.start.toFixed(2));
      bar.setAttribute('data-end', range.end.toFixed(2));
      bar.setAttribute('title', `Range ${index + 1}: $${range.start.toFixed(2)} - $${range.end.toFixed(2)} (${range.count} items)`);
      this.histogram.appendChild(bar);
    });
    
    this.logDebug(`Histogram rendered with ${ranges.length} bars`, 'success');
  }
  
  updateValues() {
    if (!this.minThumb || !this.maxThumb || !this.track || !this.minValue || !this.maxValue) {
      this.logDebug('Required elements not found for updating values', 'error');
      return;
    }
    
    // Update thumb positions
    const minPosition = ((this.currentMin - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;
    const maxPosition = ((this.currentMax - this.minPrice) / (this.maxPrice - this.minPrice)) * 100;
    
    this.minThumb.style.left = `${minPosition}%`;
    this.maxThumb.style.left = `${maxPosition}%`;
    
    // Update track
    this.track.style.left = `${minPosition}%`;
    this.track.style.width = `${maxPosition - minPosition}%`;
    
    // Update value displays
    this.minValue.textContent = `$${this.currentMin.toFixed(2)}`;
    this.maxValue.textContent = `$${this.currentMax.toFixed(2)}`;
    
    this.logDebug(`Updated values: $${this.currentMin.toFixed(2)} - $${this.currentMax.toFixed(2)}`, 'success');
  }
}

// Make PriceRangeFilter available globally
window.PriceRangeFilter = PriceRangeFilter;

// Initialize the filter when the page loads
document.addEventListener('DOMContentLoaded', () => {
  window.priceRangeFilter = new PriceRangeFilter();
  window.themeToggle.init(); // Added initialization for the new theme toggle
});

// NEW Theme Toggle Object
window.themeToggle = {
  htmlEl: null,
  systemThemeListener: null,

  init: function() {
    this.htmlEl = document.documentElement;
    this.loadInitialTheme();
  },
  loadInitialTheme: function() {
    // Check for existing theme preference (from the old implementation)
    const savedTheme = localStorage.getItem('theme') || localStorage.getItem('theme-preference');
    if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
      this.applyTheme(savedTheme);
      this.htmlEl.setAttribute('data-theme-source', 'user-preference');
      return;
    }

    // No saved theme, use data-theme attribute or system preference for 'auto'
    let initialConfigTheme = this.htmlEl.getAttribute('data-theme');
    if (!initialConfigTheme || initialConfigTheme === 'auto') {
      initialConfigTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
      this.htmlEl.setAttribute('data-theme-source', 'auto');

      // Listen for system changes if still in 'auto' mode (no theme manually saved)
      if (this.systemThemeListener) {
        window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', this.systemThemeListener);
      }
      this.systemThemeListener = (e) => {
        // Only apply if no theme has been manually set and saved by the user
        if (!localStorage.getItem('theme') && !localStorage.getItem('theme-preference')) {
          this.applyTheme(e.matches ? 'dark' : 'light', false);
        }
      };
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', this.systemThemeListener);
    } else {
       this.htmlEl.setAttribute('data-theme-source', initialConfigTheme);
    }
    this.applyTheme(initialConfigTheme, false);
  },  applyTheme: function(theme, savePreference = false) {
    console.log('Applying theme:', theme, 'savePreference:', savePreference);
    this.htmlEl.setAttribute('data-theme', theme);
    if (savePreference) {
      // Save to both localStorage keys for compatibility
      localStorage.setItem('theme', theme);
      localStorage.setItem('theme-preference', theme);
      this.htmlEl.setAttribute('data-theme-source', 'user-preference');
      console.log('Theme saved to localStorage:', theme);
    }
    // Dispatch theme changed event with proper detail object
    console.log('Dispatching theme:changed event with theme:', theme);
    document.dispatchEvent(new CustomEvent('theme:changed', { detail: { theme: theme } }));
  },

  toggleTheme: function() {
    let currentTheme = this.htmlEl.getAttribute('data-theme');
    console.log('Current theme before toggle:', currentTheme);
    // Fallback if currentTheme is not 'light' or 'dark' (e.g. if it was 'auto')
    if (currentTheme !== 'light' && currentTheme !== 'dark') {
        currentTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        console.log('Fallback theme detected:', currentTheme);
    }
    const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
    console.log('Toggling to new theme:', newTheme);
    this.applyTheme(newTheme, true); // Apply and save this user preference
    return newTheme;
  }
};

// REMOVE the old IIFE for theme detection:
/*
(function() {
  // Detect system dark mode preference
  const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)');
  const html = document.documentElement;
  
  // Apply theme based on system preference if auto theme is enabled
  if (html.getAttribute('data-theme') === 'auto') {
    if (prefersDarkMode.matches) {
      html.setAttribute('data-theme', 'dark');
    } else {
      html.setAttribute('data-theme', 'light');
    }
    
    // Listen for changes in system preference
    prefersDarkMode.addEventListener('change', e => {
      if (html.getAttribute('data-theme') === 'auto') {
        if (e.matches) {
          html.setAttribute('data-theme', 'dark');
        } else {
          html.setAttribute('data-theme', 'light');
        }
      }
    });
  }
})();
*/